export const SpotterLogoClosed = ({ className, width, height }) => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="-169 241 24.1 25.4"
    width={width}
    height={height}
    className={className}
  >
    <path
      fill="#304968"
      d="M-160.2,246c-3.3,1.3-5.7,4.5-5.7,8.4c0,5,4,9,9,9c5,0,9-4,9-9c0-1.6-0.4-3-1-4.2l2.8-1.1
	c0.8,1.6,1.3,3.4,1.3,5.3c0,6.6-5.4,12-12,12c-6.6,0-12-5.4-12-12c0-5.1,3.2-9.4,7.6-11.2"
    />
    <path
      fill="#EE9E2C"
      d="M-154.7,256.1c0,1.9-1.6,3.6-3.6,3.6c-1.9,0-3.6-1.6-3.6-3.6c0-1.9,1.6-3.6,3.6-3.6
	C-156.3,252.5-154.7,254.1-154.7,256.1z"
    />
    <path
      fill="#EE9E2C"
      d="M-154.5,250.3c0,0.7-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.7,0.6-1.4,1.4-1.4
	C-155,248.9-154.5,249.5-154.5,250.3z"
    />
    <path
      fill="#EE9E2C"
      d="M-146.6,247.2c-2.2-5.2-8.2-7.6-13.4-5.4l0.7,1.7c2.1-0.9,4.4-0.9,6.4,0c2,0.8,3.6,2.4,4.5,4.4L-146.6,247.2
	z"
    />
    <path
      fill="#EE9E2C"
      d="M-158.7,245.2l0.7,1.7c2.4-1,5.1,0.1,6.1,2.4l1.7-0.7C-151.5,245.3-155.3,243.8-158.7,245.2
	C-158.6,245.2-158.6,245.2-158.7,245.2z"
    />
  </svg>
)
